import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

export const StyledPressable = Pressable.withConfig({
  padding: '$4',
  backgroundColor: getDesignToken('background-card'),
  borderRadius: 8,
  marginBottom: spacing.$0_5,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

const styles = StyleSheet.create({
  iconContainer: {
    backgroundColor: getDesignToken('icon-active'),
    borderRadius: 9999,
    marginRight: spacing.$3,
    padding: 1.5,
  },
});

export const IconContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.iconContainer, style] });
